<div
  *ngIf="loading"
  class="absolute inset-0 bg-white/50 backdrop-blur-sm z-50 flex flex-col items-center justify-center gap-4"
>
  <div class="loader-container">
    <div class="loader"></div>
    <div class="loader-glow"></div>
  </div>
  <span class="text-foreground font-semibold text-lg animate-pulse">{{ message }}</span>
</div>
